/**
 * Welche Teile der Like/Speichern/Teilen-Leiste ein Scrolly zeigt.
 *
 * Zwei Org-Flags aus branding.badges, beide nur per DB-Workflow gesetzt:
 *   showEngagement=false  → gar nichts (so lief Weser-Kurier bis 08.09.2026)
 *   showLikeSave=false    → nur Teilen, Like und Speichern bleiben weg
 *                           (Lauras Wunsch 08.09.2026: „so wie bei allen,
 *                           nur ohne Like und Save")
 * Dazu je Scrolly:
 *   aufPortal=false       → nur Teilen: Like und Speichern gibt es nur fuer
 *                           Scrollys auf der Homepage (Jan 03.10.2026: „macht
 *                           nur im Zusammenhang mit der Homepage Sinn" — eine
 *                           privat geteilte Postkarte verlangte dafuer eine
 *                           Anmeldung)
 * Default (alles undefined/true) = alles zeigen.
 *
 * Eine Funktion fuer beide Darstellungen (Band am Scrolly-Ende und Mobil-
 * Menue), damit die Regel nicht an zwei Stellen auseinanderlaeuft.
 */
export interface EngagementFlags {
  showEngagement?: boolean;
  showLikeSave?: boolean;
  /** Steht der Scrolly auf der Homepage (Portal-Feed)? Fehlt = wie bisher. */
  aufPortal?: boolean;
}

export interface EngagementVisibility {
  /** Irgendetwas aus der Leiste zeigen? */
  any: boolean;
  /** Like + Speichern zeigen? */
  likeSave: boolean;
  /** Teilen zeigen? (immer, sobald die Leiste an ist) */
  share: boolean;
}

export function engagementVisibility(
  flags: EngagementFlags | null | undefined,
): EngagementVisibility {
  const any = flags?.showEngagement !== false;
  return {
    any,
    likeSave: any && flags?.showLikeSave !== false && flags?.aufPortal !== false,
    share: any,
  };
}
